import React, { useState } from "react";
import Result from "./Result/Result";
import Survey_Screen, { clearPageNumber } from "./Survey/Survey_Screen";
import {Model} from 'survey-react'
interface ScreensProps {}

export const Screens: React.FC<ScreensProps> = ({}) => {
  const [surveyDone, setSurveyDone] = useState(setStateWasSurveyDone);
  const [surveyData, setSurveyData] = useState<any>(setStateGetSurveyDone);
  const [survey, setSurvey] = useState<Model | null>(null);
  const back_button_clicked = () => {
    window.localStorage.setItem("survey-done", "false");
    setSurveyDone(false);
  };
  const back_to_start_clicked = () => {
    let survey_text = window.localStorage.getItem("my-survey");
    if (survey_text != null) {
      let survey_json = JSON.parse(survey_text);
      survey_json.pageNo = 1;
      window.localStorage.setItem("my-survey", JSON.stringify(survey_json));

      window.localStorage.setItem("survey-done", "false");
      clearPageNumber();
    }
    setSurveyDone(false);
  };
  const set_data = (data: any) => {
    setSurveyData(data);
    window.localStorage.setItem("survey-done", "true");
  };

  const clearSurvey = () => {
    setSurveyDone(false);
    window.localStorage.clear();
  };

  return (
    <>
      {surveyDone ? (
        <Result
          back_button_clicked={back_button_clicked}
          back_to_start_clicked={back_to_start_clicked}
          data={surveyData}
          clearSurvey={clearSurvey}
          survey={survey}
        />
      ) : (
        <Survey_Screen set_data={set_data} setSurveyDone={setSurveyDone} returnSurveyModel={(survey)=>{setSurvey(survey)}} />
      )}
    </>
  );
};

const setStateWasSurveyDone = () => {
  return window.localStorage.getItem("survey-done") === "true";
};
const setStateGetSurveyDone = () => {
  let save_data = window.localStorage.getItem("my-survey");
  if (save_data) {
    return JSON.parse(save_data);
  } else {
    return {};
  }
};
